import axios from "axios";
import { toast } from "react-toastify";
import API from "../helpers/api";

let searchData = {
  email: '',
  PageNumber: 1,
  PageSize: 25
};

let user = JSON.parse(localStorage.getItem("currentUser"));
export const AddMMPLUserDetails = (data) => {
  let url = `${API.UserAPI}`;
  return dispatch => {
    axios.post(url, data, {
      headers: {
        key: user.accessToken,
      }
    }).then((response) => {
      dispatch(getMMPLUsersList(searchData));
      dispatch({
        type: 'PostUserSuccess',
        data: response.data
      })
    }).catch((error) => {
      dispatch({
        type: 'PostUserFailure',
        data: "error"
      })
    })
  }
}
export const updateMMPLUserDetails = (data, teamsData) => {
  let url = `${API.UserAPI}`;
  let teamsurl = `${API.CreateTeams}`;
  return dispatch => {
    axios.put(url, data, {
      headers: {
        key: user.accessToken,
      }
    })
      .then((response) => {
        toast.success('Updated Successfully', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
      });
        dispatch(getMMPLUsersList(searchData));
        dispatch({
          type: "UpdateUserSuccess",
          data: response.data
        })
     axios.put(teamsurl, teamsData, {
            headers: {
                key: user.accessToken,
            }
        })
        .then((response) => {
            console.log("res", response);
          })
        .catch((error) => {
            console.log("error", error);
        })
      })
       .catch((error) => {
        dispatch({
          type: "UpdateUserFailure",
          error: "ERROR"
        })
      })
  }
}
export const DeleteMMPLUser = (data) => {
  let url = `${API.UserAPI}`;
  return dispatch => {
    axios.put(url, data)
      .then((response) => {
        dispatch(getMMPLUsersList(searchData));
        dispatch({
          type: "UserDeleteSuccess",
          data: response.data
        })
        toast.success('Deleted Successfully', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      })
      .catch((error) => {
        dispatch({
          type: "UserDeleteFailure",
          error: "ERROR"
        })
      })
  }
}
export const getMMPLUsersList = (searchitem) => {
  let url = `${API.getUser}?email=${searchitem.email}&PageNumber=${searchitem.PageNumber}&PageSize=${searchitem.PageSize}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "getUserDataSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "getUserDataFailure",
          error: "ERROR"
        })
      })
  }
}
export const getMMPLUsersDetails = (id) => {
  let url = `${API.UserAPI}?userid=${id}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "getUserDetailsSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "getUserDetailsFailure",
          error: "ERROR"
        })
      })
  }
}

